import { createModuleDescriptor } from '../../redux/module-descriptor';

import socketioSaga from './socketioSagas';
import newCustomerSaga from './newCustomerSaga';
import actions from './actions';
import reducer from './reducer';
import selectors from './selectors';
import { contact, callHistory } from './entities';
import callHistorySaga from './callHistorySaga';

const saga = [...socketioSaga, callHistorySaga, newCustomerSaga];

const communication = createModuleDescriptor('communication', {
  entities: [contact, callHistory],
  saga,
  actions,
  reducer,
  selectors,
});
export default communication;
